import React from "react";
import "./title.styles.css";

export const Title = (props) => {
    return(
        <div className="title-container">
            <img 
                alt="none"
                style={{ display:props.img?"":"none"}}
                {...props}
            ></img>
            <h1 className="title" dangerouslySetInnerHTML={{__html:props.title}} style={{display:props.title?"":"none", textTransform:props.uppercase?"uppercase":"", ...props.titlestyle}}></h1>
            <div className="description" dangerouslySetInnerHTML={{__html:props.description}} style={{display:props.description?"":"none", ...props.descstyle}} display={props.description?"":"none"}></div>
        </div>
    )
}